import React, { PureComponent, useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import Slider from 'react-slick';
import { QQShare } from 'ThreeTerminal_mobile';
import { Player } from 'ThreeTerminal_mobile/video';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import styles from './index.css';
import { formatImage } from '@ifeng/three_terminal/es/base/publicMethod/formatImage';
import { getCoverList } from '../../services/api';

const pickContent = (props, name) => {
    const { content } = props;
    let result = [];

    content.modules.forEach(item => {
        if (name === item.title) result = item.data.articleList;
    });

    result.forEach(item => {
        item.thumbnail = item.thumbnail || (item.thumbnails?.image && item.thumbnails?.image[0]?.url);
    });

    return result;
};

const isShowPickContent = (props, name) => {
    const { content } = props;
    let result = 1;

    content.modules.forEach(item => {
        if (name === item.title) result = item.display;
    });

    return result;
};

const VideoPlayer = errorBoundary(props => {
    const [videoPlay, setVideoPlay] = useState(true);
    const video = pickContent(props, '视频模块')[0];
    const isShow = isShowPickContent(props, '视频模块');

    return isShow ? (
        <div className={styles.videoPlay}>
            {videoPlay ? (
                <Player
                    videoConfig={{
                        bigPosterUrl: video.thumbnail,
                        mobileUrl: video.videoPlayUrl,
                        guid: video.guid,
                    }}
                    playermsg={{
                        showPoster: true,
                        showController: true,
                        height: 182,
                    }}
                />
            ) : null}
            <div className={styles.title}>{video.title}</div>
        </div>
    ) : (
        ''
    );
});

/**
 *  跳web： grounds.dispatch("web", "https://user.iclient.ifeng.com/payment_home_product/index?webkit=1&gv=5.6.7&os=ios_10.3.3&proid=ifengnews"); // 跳到充值界面, gv, os, proid可从getDeviceInfo中获取
 *  跳文章：grounds.dispatch("doc", url);     // url为文章id  如果前缀没有ucms_需要自己拼接前缀
 *  跳视频：grounds.dispatch("phvideo",url); // url为视频的guid 需要拼接video_前缀
 *  跳幻灯：grounds.dispatch("slide", url); // url为请求幻灯数据的接口地址，一般为https://api.3g.ifeng.com/ipadtestdoc?aid=ucms_${id}
 */
const openUrl = item => {
    if (typeof grounds !== 'undefined' && typeof window.grounds.getDeviceInfo !== 'undefined') {
        try {
            const info = window.grounds.getDeviceInfo();
            const gv = info.getGv();
            const os = info.getOs();
            const proid = info.getProid();

            switch (item.type) {
                case 'video':
                    window.grounds.dispatch('phvideo', item.guid);
                    break;

                case 'article':
                    window.grounds.dispatch('doc', `ucms_${item.id}`);
                    break;

                case 'slide':
                    window.grounds.dispatch('slide', `https://api.3g.ifeng.com/ipadtestdoc?aid=ucms_${item.id}`);
                    break;

                default:
                    window.grounds.dispatch('web', `${item.url}?webkit=1&gv=${gv}&os=${os}&proid=${proid}`);
                    break;
            }
        } catch (error) {
            window.open(item.url, '_blank');
        }
    } else if (window.location.href.includes('/c/s/')) {
        switch (item.type) {
            case 'web':
                if (item.url.includes('/c/special/')) {
                    window.open(`https://ishare.ifeng.com/c/s/${item.url.split('/').pop()}`);
                } else {
                    window.open(item.url, '_blank');
                }
                break;
            case 'live':
                window.open(item.url, '_blank');
                break;
            default:
                window.open(`https://ishare.ifeng.com/c/s/${item.base62Id}`);
                break;
        }
    } else {
        window.open(item.url, '_blank');
    }
};

const Brilliant = errorBoundary(props => {
    const [fold, setFold] = useState(true);
    const data = pickContent(props, '精彩片段模块');
    const isShow = isShowPickContent(props, '精彩片段模块');

    return isShow ? (
        <div className={styles.brilliant}>
            <img className={styles.title_img} src={require('./assets/blilliant.png')} />
            <div className={styles.content}>
                <div
                    className={styles.big}
                    onClick={() => {
                        openUrl(data[0]);
                        // window.open(data[0].url, '_blank');
                    }}>
                    <img src={data[0].thumbnail} alt="" />
                    <div>{data[0].title}</div>
                </div>
                <div className={styles.small}>
                    {data.slice(1, fold ? 5 : data.length).map((card, index) => {
                        return (
                            <div
                                key={index}
                                className={styles.card}
                                onClick={() => {
                                    openUrl(card);
                                    // window.open(card.url, '_blank');
                                }}>
                                <img src={card.thumbnail} alt="" />
                                <div>{card.title}</div>
                            </div>
                        );
                    })}
                </div>
            </div>
            {fold ? (
                <div className={styles.unfold} onClick={() => setFold(false)}>
                    <img src={require('./assets/arrow_red.png')} alt="" />
                </div>
            ) : null}
        </div>
    ) : (
        ''
    );
});

const Article = errorBoundary(props => {
    const [fold, setFold] = useState(true);
    const data = pickContent(props, '相关文章模块');
    const isShow = isShowPickContent(props, '相关文章模块');

    return isShow ? (
        <div className={styles.article}>
            <img className={styles.title_img} src={require('./assets/article.png')} />
            <div className={styles.content}>
                {data.slice(0, fold ? 4 : data.length).map((item, index) => {
                    return (
                        <div
                            key={index}
                            className={styles.item}
                            onClick={() => {
                                openUrl(item);
                                // window.open(item.url, '_blank');
                            }}>
                            <div className={styles.img}>
                                <img src={item.thumbnail} alt="" />
                            </div>
                            <div>
                                <div>{item.title}</div>
                            </div>
                        </div>
                    );
                })}
            </div>
            {fold ? (
                <div className={styles.unfold} onClick={() => setFold(false)}>
                    <img src={require('./assets/arrow_red.png')} alt="" />
                </div>
            ) : null}
        </div>
    ) : (
        ''
    );
});

const Pics = errorBoundary(props => {
    const slide = useRef(null);
    const data = pickContent(props, '嘉宾图集模块');
    const isShow = isShowPickContent(props, '嘉宾图集模块');
    const [activePic, setActivePic] = useState(0);
    const slideSettings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        variableWidth: true,
        slidesToScroll: 1,
        arrows: false,
        centerMode: false,
        autoplaySpeed: 3000,
        autoplay: true,
        centerPadding: '70px',
        draggable: false,
        afterChange: index => setActivePic(index),
    };

    return data && data.length > 0 && isShow === 1 ? (
        <div className={styles.pics}>
            <img className={styles.title_img} src={require('./assets/pics.png')} />
            <div className={styles.content}>
                <div className={styles.left}>
                    <img src={formatImage(data[activePic].thumbnail, 690, 400)} alt="" />
                    <div className={styles.title}>{data[activePic].source}</div>
                </div>
                <div className={styles.right}>
                    <div
                        className={styles.slide_left_btn}
                        onClick={() => {
                            slide.current.slickPrev();
                        }}>
                        <img src={require('./assets/arrow_red.png')} alt="" />
                    </div>
                    <div className={styles.slide_right_btn} onClick={() => slide.current.slickNext()}>
                        <img src={require('./assets/arrow_red.png')} alt="" />
                    </div>
                    <div className={styles.sliderWrapper}>
                        <Slider {...slideSettings} ref={slider => (slide.current = slider)}>
                            {data.map((item, index) => {
                                return (
                                    <div
                                        key={index}
                                        className={styles.slideImg}
                                        onClick={() => {
                                            slide.current.slickGoTo(index);
                                            slide.current.slickPlay();
                                        }}>
                                        <img src={item.thumbnail} alt="" />
                                    </div>
                                );
                            })}
                        </Slider>
                    </div>
                </div>
            </div>
        </div>
    ) : (
        ''
    );
});

const Review = errorBoundary(props => {
    const [reviewData, setReviewData] = useState([]);

    const getRevewData = async () => {
        let result = await getCoverList();

        result = result.filter(item => !location.href.includes(item.base62Id));

        setReviewData(result);
    };

    useEffect(() => {
        getRevewData();
    }, []);
    const isShow = isShowPickContent(props, '往期回顾模块');

    return isShow ? (
        <div className={styles.review}>
            <img className={styles.title_img} src={require('./assets/review.png')} />
            <div className={styles.reviewBox}>
                {reviewData.map((item, index) => {
                    return (
                        <div
                            key={index}
                            className={styles.item}
                            onClick={() => {
                                openUrl(item);
                                // const id = item.url.split('/').pop();
                                // window.open(`https://ishare.ifeng.com/c/s/${id}`, '_blank');
                            }}>
                            <img src={item.thumbnail} alt="" />
                        </div>
                    );
                })}
            </div>
        </div>
    ) : (
        ''
    );
});

class Layout extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;
        const banner = pickContent(this.props, '开屏封面');
        const thx = pickContent(this.props, '特别鸣谢模块');
        const info = pickContent(this.props, '页面尾栏');
        const share = pickContent(this.props, '分享页');
        const qqShareCofig = {
            title: share[0].source,
            img: share[2].thumbnail || 'https://p1.ifengimg.com/29b92e35b2b20708/2017/51/ifengLogo300x300.jpg',
            desc: share[1].source,
        };
        const infoImageUrl =
            (info && info[5] && info[5].thumbnail) || 'https://x2.ifengimg.com/fe/shank/custom/cover.d8084604.png';
        const isShowPageBottom = isShowPickContent(this.props, '页面尾栏');

        return (
            <div>
                <div className={styles.container}>
                    <div
                        className={styles.cover}
                        style={{
                            backgroundImage: `url(${banner[1].thumbnail})`,
                        }}
                    />
                    <VideoPlayer content={content} />
                    <Brilliant content={content} />
                    <Article content={content} />
                    <Pics content={content} />
                    <Review content={content} />
                    <div className={styles.thx}>
                        <img className={styles.title_img} src={require('./assets/thx.png')} alt="" />
                        <div>
                            {thx.map((item, index) => (
                                <div key={index} className={styles.thx_card}>
                                    <img src={item.thumbnail} alt="" />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                {isShowPageBottom ? (
                    <div className={styles.tel}>
                        <img src={infoImageUrl} alt="" />
                        <div>
                            <div>联系我们</div>
                            {info?.[4]?.source && <div>{info[4]?.title || '出品'}：{info[4].source}</div>}
                            {info?.[3].source && <div>{info[3]?.title || '执行制片人'}：{info[3].source}</div>}
                            {info?.[2]?.source && <div>{info[2]?.title || '主持人'}：{info[2].source}</div>}
                            {info?.[1]?.source && <div>{info[1]?.title || '邮箱'}：{info[1].source}</div>}
                            <div>地址：北京市朝阳区望京启阳路4号中轻大厦</div>
                        </div>
                    </div>
                ) : (
                    ''
                )}
                <QQShare content={qqShareCofig} />
            </div>
        );
    }
}

export default errorBoundary(Layout);
